import { Button, InlineAlert } from 'edrolo-style-guide';
import { FormGroup, FormControl } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import GrokSelfReflection from '../../../GrokSelfReflection';
import QuestionSolution from '../../../QuestionSolution';
import s from './styles.scss';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
// TODO: re-enable correctness ui when we can calculate it correctly
import questionTypePropInterface from '../../questionTypePropInterface';
// import cx from 'classnames';

const isValid = (value) => {
  if (value === '-') {
    return true;
  }
  if (typeof value != 'string') {
    return false;
  }
  if (isNaN(value) || isNaN(parseFloat(value))) {
    return false;
  }
  return true;
};

export const NumberOnImageQuestion = ({
  question,
  response,
  onSubmit,
  onSubmitGrok,
  grokkingItemIsSaving,
  onSubmitTeacherAnswer,
  isQuestionReview,
  isPrint,
}) => {
  const [answers, setAnswers] = useState([]);
  const imageUrl = question.get('image_url');
  const fields = question.get('fields').toJS();

  useEffect(() => {
    const fieldResponses = response?.get('field_responses').toJS();
    if (!fieldResponses?.length) {
      return;
    }

    setAnswers(
      fieldResponses.map((fieldResponse) => ({
        fieldId: fieldResponse.field_id,
        submittedValue: fieldResponse.submitted_value,
      }))
    );
  }, [response]);

  function updateAnswers(value, id) {
    let newAnswers = [...answers];

    const existingAnswer = newAnswers.find((a) => a.fieldId === id);

    if (!existingAnswer) {
      newAnswers.push({ fieldId: id, submittedValue: value });
    }

    if (existingAnswer && !value.length) {
      newAnswers = newAnswers.filter((a) => a.fieldId !== id);
    }

    if (existingAnswer && !!value.length) {
      newAnswers = newAnswers.filter((a) => a.fieldId !== id);
      newAnswers.push({
        fieldId: id,
        submittedValue: value,
      });
    }

    setAnswers(newAnswers);
  }

  const submittedFieldsValid =
    answers.filter((a) => isValid(a.submittedValue)).length === answers.length;

  const allFieldsValid =
    answers.filter((a) => isValid(a.submittedValue)).length === fields.length;

  const disableSubmission = !allFieldsValid;

  // TODO: re-enable correctness ui when we can calulate it correctly
  // const isCorrect = response?.get('is_correct', false);

  return (
    <>
      <form className={s.numberOnImage}>
        <div className={s.imageWrapper}>
          <FormGroup className={s.formGroup}>
            {fields.map((field) => {
              const { id, width, height, x_position, y_position } = field;
              const value =
                answers.find((a) => a.fieldId === id)?.submittedValue || '';

              const fieldResponses = response?.get('field_responses').toJS();
              const fieldResponse = fieldResponses?.find(
                (a) => a.field_id === id
              );

              return (
                <FormControl
                  key={id}
                  componentClass="textarea"
                  // TODO: re-enable correctness ui when we can calulate it correctly
                  // className={cx({
                  //   [s.highlightIncorrect]:
                  //     fieldResponse && !fieldResponse.is_correct,
                  // })}
                  wrap="off"
                  onChange={(e) =>
                    e.nativeEvent.inputType != 'insertLineBreak' &&
                    updateAnswers(e.target.value, id)
                  }
                  value={!response ? value : fieldResponse?.submitted_value}
                  style={{
                    left: `${x_position}%`,
                    top: `${y_position}%`,
                    height: `${height}%`,
                    width: `${width}%`,
                  }}
                  disabled={!!response}
                />
              );
            })}
          </FormGroup>
          <img src={imageUrl} />
          {/*
          TODO: re-enable correctness ui when we can calulate it correctly
          {!!response && !isQuestionReview && (
            <span className={cx(s.check, { [s.incorrect]: !isCorrect })} />
          )} */}
        </div>

        {!submittedFieldsValid && (
          <div>
            <InlineAlert type="error">
              Only valid numbers can be entered here
            </InlineAlert>
          </div>
        )}
      </form>

      {!response && !isQuestionReview && (
        <div>
          <Button
            onClick={() =>
              onSubmitTeacherAnswer
                ? onSubmitTeacherAnswer()
                : onSubmit({ fieldResponses: answers })
            }
            disabled={disableSubmission}
          >
            {onSubmitTeacherAnswer ? 'View answer' : 'Save & continue'}
          </Button>
        </div>
      )}

      {!!response && !isQuestionReview && (
        <>
          <QuestionSolution
            headingText="Solution"
            questionId={question.get('id')}
            explanation={response.getIn(['solution', 'explanation'])}
            videoHash={response.getIn([
              'solution',
              'video',
              'wistia_hashed_id',
            ])}
            videoThumbnailUrl={WistiaUtils.getThumbnail(
              response.getIn(['solution', 'video'])
            )}
          />
          {!isPrint && (
            <GrokSelfReflection
              value={response.get('grokked')}
              onChange={onSubmitGrok}
              isSaving={grokkingItemIsSaving}
            />
          )}
        </>
      )}
    </>
  );
};

NumberOnImageQuestion.propTypes = {
  ...questionTypePropInterface,
};
